/**
 * NotFoundPage — Página 404 para rutas inexistentes
 * Exporta: NotFoundPage (named + default)
 * Invoca: ErrorPage (@/pages/error/ErrorPage)
 * NO debe contener lógica de negocio.
 * Se muestra cuando el usuario navega a una ruta que no existe.
 */

import { MapPinOff } from "lucide-react";
import { ErrorPage } from "./ErrorPage";

export const NotFoundPage = () => (
  <ErrorPage
    code="404"
    title="Página no encontrada"
    description="La página que buscas no existe, fue movida o la dirección es incorrecta. Verifica la URL o regresa al inicio."
    icon={<MapPinOff className="w-12 h-12 text-primary-500" />}
    accentColor="text-primary-600 dark:text-primary-400"
  />
);

export default NotFoundPage;
